import $ from 'jquery';
import ImageCarousel from './ImageCarousel';

class NewsList {
  constructor($main) {
    if (!this.initDomElements($main)) {
      return false;
    }

    this.initEvents();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.items = this.domElements.main.find('.news-list__items');
    this.domElements.loadMoreBtn = this.domElements.main.find('.news-list__load-more-btn');
    return true;
  }

  initEvents() {
    this.domElements.loadMoreBtn.on('click', this.loadMoreNews.bind(this));
  }

  loadMoreNews() {
    const button = this.domElements.loadMoreBtn;
    const currentPage = parseInt(button.data('page'), 10);
    const totalPosts = parseInt(button.data('total'), 10);
    const postsPerPage = 3;
    const offset = currentPage * postsPerPage;

    // If we've loaded all posts, hide the button
    if (offset >= totalPosts) {
      button.hide();
      return;
    }

    // Show loading state
    button.prop('disabled', true);
    button.text('Laden...');

    // Make AJAX request to get more posts
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'load_more_news',
        offset: offset,
        posts_per_page: postsPerPage
      },
      success: (response) => {
        if (response.success) {
          // Append new posts to the list
          this.domElements.items.append(response.data.html);

          // Initialize image carousels for the newly loaded items
          this.domElements.items.find('.image-carousel').each((index, item) => {
            if (!$(item).hasClass('slick-initialized')) {
              new ImageCarousel($(item));
            }
          });

          // Update button data attribute
          button.data('page', currentPage + 1);

          // If we've loaded all posts, hide the button
          if ((currentPage + 1) * postsPerPage >= totalPosts) {
            button.hide();
          } else {
            // Reset button state
            button.prop('disabled', false);
            button.text('Weitere News laden');
          }
        } else {
          console.error('Error loading more news:', response.data.message);
          // Reset button state
          button.prop('disabled', false);
          button.text('Weitere News laden');
        }
      },
      error: (xhr, status, error) => {
        console.error('AJAX error:', error);
        // Reset button state
        button.prop('disabled', false);
        button.text('Weitere News laden');
      }
    });
  }
}

export default NewsList;
